import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    MenuItem,
    TextField,
} from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

import { currencies, taxRates, units } from "./articleUtils";

export default function ArticleDialog({
    open,
    onClose,
    onSave,
    editingIndex,
    currentArtikel,
    fieldErrors,
    gross,
    onFieldChange,
    onToggleHasAmount,
}) {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" PaperProps={{ sx: { borderRadius: 3 } }}>
            <DialogTitle>
                {editingIndex !== null ? "Artikel bearbeiten" : "Artikel hinzufügen"}
                <IconButton aria-label="Schließen" onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
                    <CloseRoundedIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid2 container spacing={2}>
                    <Grid2 xs={12} sm={6}>
                        <TextField
                            label="Artikelnummer"
                            value={currentArtikel.articleNumber}
                            onChange={(event) => onFieldChange("articleNumber", event.target.value)}
                            fullWidth
                            error={Boolean(fieldErrors.articleNumber)}
                            helperText={
                                fieldErrors.articleNumber || "Eindeutige Artikelnummer. Wird automatisch vorgeschlagen."
                            }
                        />
                    </Grid2>

                    <Grid2 xs={12} sm={6}>
                        <TextField
                            label="Name"
                            value={currentArtikel.name}
                            onChange={(event) => onFieldChange("name", event.target.value)}
                            fullWidth
                            required
                            error={Boolean(fieldErrors.name)}
                            helperText={fieldErrors.name || ""}
                        />
                    </Grid2>

                    <Grid2 xs={12}>
                        <TextField
                            label="Beschreibung"
                            value={currentArtikel.description}
                            onChange={(event) => onFieldChange("description", event.target.value)}
                            fullWidth
                            multiline
                            minRows={3}
                        />
                    </Grid2>

                    <Grid2 xs={12} sm={6}>
                        <TextField
                            label="Netto-Preis"
                            type="number"
                            value={currentArtikel.price}
                            onChange={(event) => onFieldChange("price", event.target.value)}
                            fullWidth
                            inputMode="decimal"
                            inputProps={{ step: "0.01", min: "0" }}
                            error={Boolean(fieldErrors.price)}
                            helperText={fieldErrors.price || ""}
                        />
                    </Grid2>

                    <Grid2 xs={12} sm={6}>
                        <TextField
                            select
                            label="Steuersatz (%)"
                            value={currentArtikel.taxRate}
                            onChange={(event) => onFieldChange("taxRate", event.target.value)}
                            fullWidth
                            error={Boolean(fieldErrors.taxRate)}
                            helperText={fieldErrors.taxRate || ""}
                        >
                            {taxRates.map((rate) => (
                                <MenuItem key={rate} value={rate}>
                                    {rate} %
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid2>

                    <Grid2 xs={12} sm={6}>
                        <TextField
                            label="Brutto (automatisch)"
                            value={Number.isFinite(gross) ? gross.toFixed(2) : ""}
                            fullWidth
                            disabled
                        />
                    </Grid2>

                    <Grid2 xs={12} sm={6}>
                        <TextField
                            select
                            label="Währung"
                            value={currentArtikel.currency}
                            onChange={(event) => onFieldChange("currency", event.target.value)}
                            sx={{ minWidth: 160 }}
                            error={Boolean(fieldErrors.currency)}
                            helperText={fieldErrors.currency || ""}
                        >
                            {currencies.map((currency) => (
                                <MenuItem key={currency} value={currency}>
                                    {currency}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid2>

                    <Grid2 xs={12} sm={6}>
                        <TextField
                            select
                            label="Einheit"
                            value={currentArtikel.unit}
                            onChange={(event) => onFieldChange("unit", event.target.value)}
                            sx={{ minWidth: 160 }}
                            error={Boolean(fieldErrors.unit)}
                            helperText={fieldErrors.unit || ""}
                        >
                            {units.map((unit) => (
                                <MenuItem key={unit} value={unit}>
                                    {unit}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid2>

                    <Grid2 xs={12} sm={6}>
                        <TextField
                            select
                            label="Lagerbestand verwalten?"
                            value={currentArtikel.hasAmount ? "yes" : "no"}
                            onChange={(event) => onToggleHasAmount(event.target.value === "yes")}
                        >
                            <MenuItem value="no">Nein</MenuItem>
                            <MenuItem value="yes">Ja</MenuItem>
                        </TextField>
                    </Grid2>

                    {currentArtikel.hasAmount && (
                        <Grid2 xs={12} sm={6}>
                            <TextField
                                label="Bestand (Menge)"
                                type="number"
                                value={currentArtikel.amount}
                                onChange={(event) => onFieldChange("amount", event.target.value)}
                                fullWidth
                                inputMode="decimal"
                                inputProps={{ step: "0.01", min: "0" }}
                                error={Boolean(fieldErrors.amount)}
                                helperText={fieldErrors.amount || ""}
                            />
                        </Grid2>
                    )}
                </Grid2>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button onClick={onClose}>Abbrechen</Button>
                <Button
                    onClick={onSave}
                    variant="contained"
                    sx={{ bgcolor: "orange", "&:hover": { bgcolor: "#cc7a00" }, borderRadius: 2, color: "#000" }}
                >
                    Speichern
                </Button>
            </DialogActions>
        </Dialog>
    );
}
